import { render, staticRenderFns } from "./AssignmentStatusChip.vue?vue&type=template&id=1e102cb4"
import script from "./AssignmentStatusChip.vue?vue&type=script&lang=js"
export * from "./AssignmentStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports